import { Switch as BaseSwitch } from '@blueprintjs/core'
import styled from 'styled-components'

export const Switch = styled(BaseSwitch)`
  display: inline-block;
  margin-bottom: 0;
  white-space: nowrap;
`
